import lscache from 'lscache';
import { FC, useEffect } from 'react';
import dayjs from 'dayjs';
import iconRollover from 'static/images/icons/rollover.svg';
import iconTransfer from 'static/images/icons/transfer.svg';
import security from 'stores/security';
import { openIRALimitsModal } from '../helper';
import Card from './Card';
import './style.scss';

const CONFIRMED_DATE_KEY = 'IRA_DEPOSIT_LIMIT_CONFIRMED_DATE';

const ContributionEnter: FC = () => {
    const isIRA = security.isIRAAccount;

    useEffect(() => {
        // 每天进入到 IRA 入金页面需要弹窗提示，当天确认过之后不再弹窗
        const today = dayjs().format('YYYY-MM-DD');
        const confirmed = today === lscache.get(CONFIRMED_DATE_KEY);

        if (confirmed || !isIRA) {
            return;
        }

        openIRALimitsModal().result.finally(() => {
            lscache.set(CONFIRMED_DATE_KEY, today, 1440);
        });
    }, [isIRA]);

    return (
        <div className="deposit-select-way-root">
            <h3 className="main-title">{__('Choose the contribution method')}</h3>
            <Card
                to="/profile/deposit/contribution"
                title={__('Contribution or Rollover')}
                icon={iconRollover}
                mode="simple"
            />
            <Card to="/profile/transfer" title={__('Trustee-to-Trustee Transfer')} icon={iconTransfer} mode="simple" />
        </div>
    );
};

export default ContributionEnter;
